// extracted by mini-css-extract-plugin
module.exports = {"card":"PostcardFront_card__wEar9","text":"PostcardFront_text__2AJJO"};